import { defineStore } from "pinia";
import { useAuthStore } from "./authStore.js";
import { useBranchesStore } from "./branchesStore.js";

export const useActiveBranchStore = defineStore("activeBranch", {
  state: () => ({
    active: "", // "ALL" or branchCode
    initialized: false,
  }),
  getters: {
    isAll: (s) => s.active === "ALL",
  },
  actions: {
    async init() {
      if (this.initialized) return;
      const auth = useAuthStore();
      if (!auth.isAuthenticated) {
        this.active = "";
        this.initialized = true;
        return;
      }
      const branchesStore = useBranchesStore();
      try {
        await branchesStore.fetch();
      } catch (err) {
        console.warn("[activeBranch] fetch branches failed", err);
      }
      const codes = (auth.branchCodes || [])
        .map((c) =>
          String(c ?? "")
            .trim()
            .toUpperCase(),
        )
        .filter(Boolean);
      if (!codes.length) {
        this.active = ""; // no branch assigned
      } else if (codes.includes("ALL")) {
        this.active = "ALL";
      } else {
        // default first branch code
        this.active = codes[0];
      }
      this.initialized = true;
    },
    setActive(code) {
      this.active = code;
    },
  },
});
